import ajax from '@fdaciuk/ajax'
class JoinAlians
{
  constructor()
  {
  }
  init()
  {
    const joinButton = document.querySelector('.js-join-alians');
    if(joinButton)
    {
      joinButton.addEventListener('click', joinAlians);
      const notice = document.querySelector('.alians-popup__header');
      function joinAlians()
      {
        let url = window.location.origin+'/wp-admin/admin-ajax.php/?action=joinalians';
        let postUrl = window.location.href;
        let form = document.querySelector('.js-join-alians-form');
        let formData = new FormData(form);
        let result = Object.fromEntries(formData);
        form.addEventListener('submit', (e) => {
          e.preventDefault();
        })
        let request = ajax
        (
          {
            method: 'POST',
            url: url,
            data:
              {
                url : postUrl,
                formData: result,
              }
          }
        )
        request.then(function(response)
        {
          notice.innerHTML = response;
        })
      }
    }
  }
}

export default new JoinAlians();
